import React from "react";
import {
  CreateSpecificationInformation,
  LoaderWrapper,
  ManageFeeLayout,
} from "../../../components";
import {
  FLOW_TYPES,
  MANAGE_FEE_ROUTES,
  formFields,
  getAdvancedPathWithParam,
  manageFeeFormNames,
  synchronizeCollectionNew,
} from "../../../utils";
import { Formik } from "formik";
import { get, set } from "lodash";
import {
  addSpecificationDetails,
  getFeeSpecificationDetailsById,
} from "../../../services";
import { manageFeeStore, setManageFeeToastInfo } from "../../../contexts";
import { useContext } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Form } from "react-bootstrap";
import { useState } from "react";
import { filterOutLastFeeTier } from "../CalculationContainer/CreateSpecificationSlider";
import { useDeepEffect, useRouterParams } from "../../../abstracts";

function CreateSpecificationInformationContainer(props) {
  const formName = manageFeeFormNames.CREATE_SPECIFICATION_INFORMATION;
  const { state, dispatch } = useContext(manageFeeStore);
  const { specificationId, flow } = useRouterParams();
  const [isLoading, setIsLoading] = useState(false);
  const [feeSpecificationDetails, setFeeSpecificationDetails] = useState({});
  const fields = formFields[formName];
  const initialValues = {
    ...feeSpecificationDetails,
  };
  const history = useHistory();
  const onCancelClick = () => {
    history.push(
      getAdvancedPathWithParam({
        path: MANAGE_FEE_ROUTES.SPECIFICATION_INFORMATION,
      })
    );
  };
  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      onClick: onCancelClick,
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
      // onClick: onFormSubmit,
    },
    {
      label: "Edit",
      variant: "primary",
      flow: [FLOW_TYPES.EDIT],
      onClick: () => {
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_FEE_ROUTES.CREATE_SPECIFICATION_INFORMATION,
            pathParam: [FLOW_TYPES.SAVE, specificationId],
          })
        );
      },
    },
  ];
  const transformValues = (values) => ({
    ...values,
    id: parseInt(specificationId ?? 0),
    feeTiers: synchronizeCollectionNew(
      get(feeSpecificationDetails, fields.feeTiers, []),
      filterOutLastFeeTier(values[fields.feeTiers]).map((tier, index) => {
        return {
          ...tier,
          order: index,
        };
      }),
      "id"
    ),
  });
  useDeepEffect(() => {
    if (specificationId) {
      setIsLoading(true);
      getFeeSpecificationDetailsById(parseInt(specificationId))
        .then((res) => {
          setIsLoading(false);
          if (res.isSuccessfull) {
            setFeeSpecificationDetails(res?.feeSpecificationDetails);
          }
        })
        .catch((err) => {
          setIsLoading(false);
        });
    }
  }, []);
  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setErrors }
  ) => {
    setIsLoading(true);
    addSpecificationDetails(transformValues(values))
      .then((res) => {
        setIsLoading(false);
        if (res.isSuccessful) {
          history.push(
            getAdvancedPathWithParam({
              path: MANAGE_FEE_ROUTES.SPECIFICATION_INFORMATION,
            })
          );
          dispatch(
            setManageFeeToastInfo({
              showToast: true,
              toastMessage: "Data saved successfully",
            })
          );
        } else {
          let errorMessages = {};
          for (var i = 0; i < res.errorMessages.length; i++) {
            var _ = res.errorMessages[i];
            if (_.controlName === fields.feeTiers) {
              const fieldNameAccountBalanceFrom = `${
                fields.feeTiers
              }.${0}.from`;
              const fieldNameAccountBalanceTo = `${fields.feeTiers}.${0}.to`;
              const fieldNameFeeAmount = `${
                fields.feeTiers
              }.${0}.percentageOrAmountOrBasisPoints`;
              set(
                errorMessages,
                fieldNameAccountBalanceFrom,
                `${_.errorCode} : ${_.message}`
              );
              set(
                errorMessages,
                fieldNameAccountBalanceTo,
                `${_.errorCode} : ${_.message}`
              );
              set(
                errorMessages,
                fieldNameFeeAmount,
                `${_.errorCode} : ${_.message}`
              );
            } else if (_.controlName === "lastFeeTier") {
              const fieldNameFeeAmount = `${
                fields.feeTiers
              }.${0}.percentageOrAmountOrBasisPoints`;
              set(
                errorMessages,
                `${fields.feeTiers}.${values[fields.feeTiers].length - 1}.to`,
                `${_.errorCode} : ${_.message}`
              );
              setErrors(errorMessages);
            } else {
              setFieldTouched(_.controlName, true);
              set(
                errorMessages,
                _.controlName,
                `${_.errorCode} : ${_.message}`
              );
            }
          }
          setErrors(errorMessages);
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };
  return (
    <div className="h-100 overflow-scroll">
      <Formik
        initialValues={{
          [fields.feeType]: null,
          ...initialValues,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={onFormSubmit}
      >
        {(formProps) => {
          const {
            handleChange,
            setFieldValue,
            handleSubmit,
            setValues,
            setTouched,
            values,
            setSubmitting,
            setFieldError,
            fieldValue,
            resetForm,
            dirty,
            validateForm,
            errors,
            ...rest
          } = formProps;
          console.log("values", values);
          return (
            <Form autoComplete="off" className="h-100" onSubmit={handleSubmit}>
              <LoaderWrapper isLoading={isLoading}>
                <ManageFeeLayout
                  buttons={buttons}
                  layoutHeader="Create Specification Information"
                  pageFlow={flow}
                >
                  <CreateSpecificationInformation
                    isMasterSpecification={true}
                    fields={fields}
                    flow={flow}
                    {...formProps}
                  />
                </ManageFeeLayout>
              </LoaderWrapper>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

export default CreateSpecificationInformationContainer;
